(ns ui.view.card.property-list.event
  (:require
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.fx.timeout :as timeout]
   [ui.state.session.model :as session-model]
   [frontend.actions.entity :as entity-actions]
   [ui.view.card.property-list.model :as model]
   [ui.view.card.model :as common-model]
   [potpuri.core :as p]
   [ui.cofx.response :as response-cofx]))

(defn toggle-edit-mode-event-fx-handler
  [{:keys [db]} [{:keys [card-state-path] :as _ctx}]]
  {:db (update-in db (model/edit-mode-full-path card-state-path) not)})

(defn toggle-show-all-fields-in-editor-event-db-handler
  [db [{:keys [card-state-path] :as _ctx}]]
  (update-in db (model/show-all-fields-in-editor-full-path card-state-path) not))

(defn edit-field-value-event-db-handler
  [db [{:keys [card-state-path entity-id] :as _ctx}
       {:keys [field value value-option-or-options] :as _args}]]
  (let [value-option-entities-by-id
        (cond (map? value-option-or-options)
              (let [id (or (:db/id value-option-or-options)
                           (:value value-option-or-options))]
                {id (assoc value-option-or-options :db/id id)})

              (or (sequential? value-option-or-options)
                  (set? value-option-or-options))
              (->> value-option-or-options
                   (mapv (fn [opt]
                           (let [id (or (:db/id opt)
                                        (:value opt))]
                             [id (assoc opt :db/id id)])))
                   (into {}))
              :else nil)]
    (cond-> db
      true
      (assoc-in (model/entity-edits-field-value-full-path card-state-path entity-id field) value)

      value-option-entities-by-id
      (assoc-in (model/entity-edit-entities-full-path card-state-path) value-option-entities-by-id))))

(rf/reg-event-fx
 ::create-option-success
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path entity-id] :as ctx}
                    {:keys [field data-type] :as _cell-data}
                    cb-data]]
   (let [card-entities (common-model/get-entities db card-state-path)
         entity (get card-entities entity-id)
         entity-edits (get-in db (model/entity-edits-full-path card-state-path))
         prev-value (if (contains? entity-edits field)
                      (get entity-edits field)
                      (get entity field))

         new-option-entity (:entity cb-data)
         new-option-id (:db/id new-option-entity)
         new-value (case data-type
                     :data.type/ref-single
                     new-option-id

                     :data.type/ref-multi
                     ((fnil conj []) prev-value new-option-id))]
     {:fx [[:dispatch [::edit-field-value ctx {:field field
                                               :value new-value
                                               :value-option-or-options new-option-entity}]]]})))

(defn save-changes-success-event-fx-handler
  [{:keys [db stale-response?]} [{:keys [card-state-path updated-entity]} _resp]]
  (when-not stale-response?
    (let [entity-id (:db/id updated-entity)
          new-db (-> db
                     (assoc-in (model/edit-mode-full-path card-state-path) false)
                     (assoc-in (model/saving-changes-full-path card-state-path) false)
                     (p/dissoc-in (model/entity-edits-full-path card-state-path))
                     (p/dissoc-in (model/entity-edit-entities-full-path card-state-path))
                     (p/dissoc-in (model/show-all-fields-in-editor-full-path card-state-path))
                     (p/dissoc-in (model/submit-errors-full-path card-state-path))
                     (common-model/merge-entities card-state-path {entity-id updated-entity}))]
      {:db new-db})))

(defn save-changes-error-event-fx-handler
  [{:keys [db stale-response?]} [{:keys [card-state-path]} {:keys [error message] :as error-resp}]]
  (when-not stale-response?
    (let [prev-submit-errors (get-in db (model/submit-errors-full-path card-state-path))
          prev-submit-errors (if (seq prev-submit-errors)
                               (vec prev-submit-errors)
                               [])
          submit-errors (vec (distinct (conj prev-submit-errors message)))
          new-db (-> db
                     (assoc-in (model/submit-errors-full-path card-state-path) submit-errors)
                     (assoc-in (model/saving-changes-full-path card-state-path) false))]
      {:db new-db})))

(defn save-changes-event-fx-handler
  "use rf/trim-v"
  [{:keys [db]} [{:keys [card-state-path] :as _ctx}]]
  (let [account-id (session-model/get-account-id db)
        entities (common-model/get-entities db card-state-path)
        entity-edits (get-in db (model/entity-edits-full-path card-state-path))

             ;; TODO fix this to support editing multiple entities at once
        primary-entity-id (first (keys entity-edits))
        prev-primary-entity (get entities primary-entity-id)
        primary-entity-edits (get entity-edits primary-entity-id)
        updated-primary-entity (merge
                                prev-primary-entity
                                primary-entity-edits
                                {:common/updated-by account-id})

        update-fx [::entity-actions/*->entity-update!
                   {:entity-id primary-entity-id
                    :updates-map primary-entity-edits
                    :on-success [::on-save-changes-success {:updated-entity updated-primary-entity
                                                            :card-state-path card-state-path}]
                    :on-error [::on-save-changes-error {:entity-id primary-entity-id
                                                        :updates primary-entity-edits
                                                        :card-state-path card-state-path}]}]
        new-db (-> db
                   (assoc-in (model/saving-changes-full-path card-state-path) true))]
    {:db new-db
     :fx [update-fx]}))

(defn discard-edits-event-fx-handler
  "use rf/trim-v"
  [{:keys [db]} [{:keys [card-state-path] :as _ctx}]]
  (let [new-db (-> db
                   (assoc-in (model/edit-mode-full-path card-state-path) false)
                   (p/dissoc-in (model/entity-edits-full-path card-state-path))
                   (p/dissoc-in (model/entity-edit-entities-full-path card-state-path))
                   (p/dissoc-in (model/show-all-fields-in-editor-full-path card-state-path))
                   (p/dissoc-in (model/submit-errors-full-path card-state-path)))]
    {:db new-db}))

  ;; Register handlers

(rf/reg-event-fx
 ::discard-edits
 [rf/trim-v]
 discard-edits-event-fx-handler)

(rf/reg-event-fx
 ::save-changes!
 [rf/trim-v]
 save-changes-event-fx-handler)

(rf/reg-event-fx
 ::on-save-changes-error
 [rf/trim-v
  response-cofx/stale-response?]
 save-changes-error-event-fx-handler)

(rf/reg-event-fx
 ::on-save-changes-success
 [rf/trim-v
  response-cofx/stale-response?]
 save-changes-success-event-fx-handler)

(rf/reg-event-db
 ::edit-field-value
 [rf/trim-v]
 edit-field-value-event-db-handler)

(rf/reg-event-fx
 ::toggle-edit-mode
 [rf/trim-v]
 toggle-edit-mode-event-fx-handler)

(rf/reg-event-db
 ::toggle-show-all-fields-in-editor
 [rf/trim-v]
 toggle-show-all-fields-in-editor-event-db-handler)
